import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor() { }

  toggleNav: Boolean = false;

  ngOnInit(): void {
  }

  onClickNavToggle() {
    this.toggleNav = !this.toggleNav;
  }

  onClickItem() {
    this.toggleNav = false;
  }

}
